<template>
    <main-section class="main-notice main-section--xs">
        <v-row>
            <v-col cols="12" md="8">
                <main-notice-list />
            </v-col>
            <v-col cols="12" md="4">
                <ul class="main-notice__scedule">
                    <li v-for="(item, index) in items" :key="index">
                        <v-card :href="item.route" target="_blank" :img="item.image" height="100%" tile flat>
                            <v-card-title>
                                {{ item.title }}
                            </v-card-title>
                            <v-card-text>재단실 신청하기<v-icon>mdi-chevron-right</v-icon></v-card-text>
                        </v-card>
                    </li>
                </ul>
            </v-col>
        </v-row>
    </main-section>
</template>

<script>
import MainSection from "@/sets/styles/mains/main-section.vue";
import MainNoticeList from "./main-notice-list.vue";
import IconChevron from "@/components/publish/styles/icons/icon-chevron.vue";

export default {
    components: {
        MainSection,
        MainNoticeList,
        IconChevron,
    },
    data() {
        return {
            items: [
                {
                    title: "답십리",
                    image: "/images/main/schedule-1.webp",
                    route: "https://cam.apparelbase.com/home/dfc",
                },
                {
                    title: "신설동",
                    image: "/images/main/schedule-2.webp",
                    route: "https://cam.apparelbase.com/home/dfc2",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.main-notice {
    &__scedule {
        height: 100%;
        display: flex;
        flex-direction: column;
        gap: 4px;
        > li {
            flex-grow: 1;
            flex-basis: 0;
            min-height: 120px;
            @media (min-width: 768px) {
                min-height: 152px;
            }
            .v-card {
                display: flex;
                flex-direction: column;
                justify-content: center;
                text-align: center;
                &__title,
                &__text {
                    color: #fff;
                    padding: 0;
                    font-size: 20px;
                    line-height: 1.5;
                    @media (min-width: 768px) {
                        font-size: 24px;
                    }
                }
                &__title {
                    justify-content: center;
                    font-weight: 700;
                }
                &__text {
                    .v-icon {
                        color: inherit;
                        transition: transform 0.2s ease-in-out;
                    }
                }
                &:hover {
                    .v-card__text {
                        .v-icon {
                            transform: translateX(4px);
                        }
                    }
                }
            }
        }
    }
    @media (min-width: 768px) {
    }
}
</style>
